import { api, ApiError } from './apiClient'

export const UsersApi = {
  getUsers() {
    return api.get('/api/admin/users')
  },

  getRoles() {
    return api.get('/api/admin/roles')
  },

  updateUserRoles(userId, roleIds) {
    return api.put(`/api/admin/users/${userId}/roles`, { roleIds })
  },

  sendInvitation(data) {
    return api.post('/api/admin/invitations', data)
  },

  getInvitations() {
    return api.get('/api/admin/invitations')
  },

  resendInvitation(id) {
    return api.post(`/api/admin/invitations/${id}/resend`)
  },

  cancelInvitation(id) {
    return api.delete(`/api/admin/invitations/${id}`)
  },

  validateInviteToken(token) {
    return api.get('/api/invite/validate', { token })
  },

  acceptInviteToken(token) {
    return api.post(`/api/invite/accept?token=${encodeURIComponent(token)}`)
  },

  getPendingInvitations() {
    return api.get('/api/invitations/pending')
  },

  acceptInvitation(id) {
    return api.post(`/api/invitations/${id}/accept`)
  },

  rejectInvitation(id) {
    return api.post(`/api/invitations/${id}/reject`)
  }
}

export { ApiError }
